import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import { PaymentIntent, PaymentIntentDto } from "../payment-intent/PaymentIntent"

type PaymentIntentPayload = {
    externalId: string
    paymentProcessorKey: string
    paymentMethodType: string
    savePaymentMethodOnFile: boolean
    accountId: string
}

class PaymentIntentService {
    static paymentIntentHttpClient: HttpClient<PaymentIntent, PaymentIntentDto> =
        new HttpClient<PaymentIntent, PaymentIntentDto>(PaymentIntent)

    static async createPaymentIntent(payload: PaymentIntentPayload): Promise<PaymentIntent | HttpError> {
        const res = await this.paymentIntentHttpClient.post("/payment-intents", payload)
        if (isError(res)) {
            return res as HttpError
        }

        return res as PaymentIntent
    }
}

export default PaymentIntentService


// WEBPACK FOOTER //
// ./src/state/payment-intent/PaymentIntentService.tsx